/* ==========================================================================
 * urlaub-free-gift.js  ·  Vitrogena / PonyHütchen  ·  v2 (theme-agnostisch)
 * Legt automatisch das Gratis-Sisalsäckchen in den Warenkorb, sobald der
 * Warenkorbwert (ohne Säckchen) >= 30 EUR ist. Die "kostenlos"-Logik kommt
 * aus dem nativen "Kaufe X, erhalte Y"-Rabatt (Säckchen 07/2026).
 *
 * v2-Unterschied: löst NICHT nur bei fetch() aus, sondern auch bei
 * XMLHttpRequest und per Polling-Fallback -> funktioniert auch in Funnel-/
 * Custom-Themes, die den Cart nicht über fetch ansprechen.
 *
 * Einbau: assets/urlaub-free-gift.js  +  vor </body> in theme.liquid:
 *   <script src="{{ 'urlaub-free-gift.js' | asset_url }}" defer></script>
 * ========================================================================== */
(function () {
  'use strict';

  // --- Konfiguration --------------------------------------------------------
  const GIFT_VARIANT_ID    = 44295559479591; // Sisalsäckchen, SKU PH-SISAL
  const MIN_SUBTOTAL_CENTS = 3000;            // 30,00 EUR
  const POLL_MS            = 2000;            // Fallback-Intervall
  // -------------------------------------------------------------------------

  let busy = false;
  let lastSig = null;

  const getCart = () =>
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());

  const qualifyingSubtotal = cart =>
    cart.items
      .filter(i => i.variant_id !== GIFT_VARIANT_ID)
      .reduce((s, i) => s + i.final_line_price, 0);

  const giftInCart = cart => cart.items.some(i => i.variant_id === GIFT_VARIANT_ID);
  const qualifies  = cart => qualifyingSubtotal(cart) >= MIN_SUBTOTAL_CENTS;
  const signature  = cart => cart.item_count + ':' + cart.items_subtotal_price;

  const addGift = () =>
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 1 }),
    });

  const removeGift = () =>
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 0 }),
    });

  async function reconcile() {
    if (busy) return;
    busy = true;
    try {
      let cart = await getCart();
      const should = qualifies(cart);
      const has = giftInCart(cart);

      if (should && !has)      { await addGift();    cart = await getCart(); refreshCartUI(); }
      else if (!should && has) { await removeGift(); cart = await getCart(); refreshCartUI(); }

      lastSig = signature(cart);
    } catch (e) {
      console.error('[URLAUB-Gift]', e);
    } finally {
      busy = false;
    }
  }

  // Theme-Cart neu zeichnen. Deckt die gängigsten Drawer-Events ab.
  // Falls dein Drawer danach trotzdem erst beim Neu-Öffnen aktualisiert:
  // sag mir den Drawer-Selektor, dann verdrahte ich den exakten Rerender.
  function refreshCartUI() {
    ['cart:refresh', 'cart:updated', 'cart:build', 'ajaxProduct:added']
      .forEach(name => document.dispatchEvent(new CustomEvent(name)));
    if (window.Shopify && typeof window.Shopify.onCartUpdate === 'function') {
      try { window.Shopify.onCartUpdate(); } catch (_) {}
    }
  }

  function isCartMutation(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?/.test(url || '');
  }

  // (1) fetch abfangen
  const origFetch = window.fetch;
  window.fetch = function (...args) {
    const p = origFetch.apply(this, args);
    try {
      const url = typeof args[0] === 'string' ? args[0] : args[0] && args[0].url;
      if (!busy && isCartMutation(url)) p.then(() => queueMicrotask(reconcile));
    } catch (_) {}
    return p;
  };

  // (2) XMLHttpRequest abfangen (viele Funnel-/Custom-Themes)
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__isCartMut = isCartMutation(url);
    return origOpen.apply(this, arguments);
  };
  const origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__isCartMut) {
      this.addEventListener('loadend', () => { if (!busy) queueMicrotask(reconcile); });
    }
    return origSend.apply(this, arguments);
  };

  // (3) Polling-Fallback: erkennt Cart-Änderungen, die (1)+(2) verpassen
  async function poll() {
    if (busy || document.hidden) return;
    try {
      const cart = await getCart();
      const sig = signature(cart);
      if (sig !== lastSig) { lastSig = sig; reconcile(); }
    } catch (_) {}
  }

  document.addEventListener('DOMContentLoaded', reconcile);
  setInterval(poll, POLL_MS);
})();